import { io } from 'socket.io-client';
import config from './../config.json';



const socket = io(config.api_address);

export default socket;

